const user = {
    state: {
        userInfo: {},
        teacherRole: {},//教师角色
    },
    //set方法
    mutations: {
        // setIsJudges
    },
    actions: {
        // login({ commit, state }) {
        //     return new Promise((resolve, reject) => {
        //         resolve()
        //     })
        // }
    }
};

export default user;
